import React, { useEffect, useState } from "react";
import { Box, TablePagination } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import InputSearch from "components/Input/InputSearch";
import { useDispatch } from "react-redux";
import {
  searchWorkerByJobId,
  addWorkerToJob
} from "store/slices/job";
import JobUserTag from "./JobUserTag";
import TablePaginationActions from "views/Admin/Component/Table/TablePaginationActions";

const SearchWorkerModal = (props) => {
  const {
    jobId,
    loadWorkersApplied
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [workers, setWorkers] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [queries, setQueries] = useState({
    asc_sort: true,
    page: 1,
    size: 10,
    search_key: "",
    sort_field: "name",
  });

  useEffect(() => {
    handleSearchWorker('');
  }, []);

  const handleSearchWorker = async (searchText) => {
    await _loadData({ search_key: searchText, page_number: 1 })
  };
  const handleAddWorkerToJob = async ({ id: workerId }) => {
    const params = {
      workerId: workerId,
      jobId: jobId,
      isAdd: true
    }
    await dispatch(addWorkerToJob(params));
    _loadData();
    loadWorkersApplied && loadWorkersApplied();
  };

  const _loadData = async ({ page_number, page_size, search_key, asc_sort, sort_field } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page_number) {
      newQueries.page = page_number;
    }
    if (page_size) {
      newQueries.size = page_size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    newQueries.search_key = search_key || "";
    newQueries.asc_sort = !(!asc_sort || false);
    const result = await dispatch(searchWorkerByJobId({ ...newQueries, jobId: jobId, }));
    const { payload } = result;
    if (payload) {
      setWorkers(payload.content);
      setTotalElements(payload.totalElements);
    }
    setQueries(newQueries);
  };

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page_number: newPage + 1 });
  };
  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page_number: 1,
      page_size: parseInt(event.target.value),
    });
  };

  return (
    <Box>
      <InputSearch
        onSearch={handleSearchWorker}
        onSearching={handleSearchWorker}
      />
      <Box>
        {
          workers.map((item, index) => {
            return (
              <JobUserTag
                key={`worker-${index}`}
                userInfo={item}
                onAdd={handleAddWorkerToJob}
                isSearching
              />
            )
          })
        }
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          count={totalElements}
          rowsPerPage={queries.size}
          page={queries.page - 1}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
          labelRowsPerPage={`${t("label.rows_per_page")}:`}
          labelDisplayedRows={({ from, to, count }) =>
            t("label.from_to", {
              from,
              to,
              count:
                count !== -1 ? count : `${t("text.more_than")} ${to}`,
            })
          }
        />
      </Box>
    </Box>
  );
}

SearchWorkerModal.propTypes = {
  jobId: PropTypes.any,
  loadWorkersApplied: PropTypes.func
};

export default SearchWorkerModal;
